<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-circle-question"></i></span>{{ 'FaqMaintenance.Header' | translate }}</h1>
  <p-card>
      <p-accordion>
          <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
              <form [formGroup]="searchForm">
                  <div class="p-fluid formgrid grid">
                      <div class="col-12 md:col-6 lg:col-4 mb-3">
                          <label>{{ 'FaqMaintenance.Search.Facility' | translate }}</label>
                          <laas-facility-dropdown
                            formControlName="facility"
                            [isMultiple]="true"
                            [showFilter]="true"
                            [showToggleAll]="true"
                          >
                          </laas-facility-dropdown>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4 mb-3">
                          <label>{{ 'FaqMaintenance.Search.Keyword' | translate }}</label>
                          <input pInputText type="text" formControlName="keyword"/>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4 mb-3">
                          <label>{{ 'FaqMaintenance.Search.IsActivated' | translate }}</label>
                          <p-dropdown formControlName="isActivated" [options]="isActivatedOptions" [showClear]="true"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                          </p-dropdown>
                      </div>

                      <div class="col-12 md:col-6 lg:col-4 mb-3">
                        <label>{{ 'NotificationSubscribtion.Form.Tenant' | translate }}</label>
                        <p-multiSelect formControlName="tenantList" [options]="tenantOptions" [filter]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                      </p-multiSelect>
                    </div>

                  </div>
                  <div class="grid">
                      <div class="col">
                          <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
                          <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button>
                          <button pButton pRipple label="{{ 'FaqMaintenance.Button' | translate }}" (click)="addFaq($event)" class="p-button-info ml-2"></button>
                      </div>
                  </div>
              </form>
          </p-accordionTab>
      </p-accordion>
      <div class="mt-2">
          <p-table [columns]="columns" [value]="faqResults" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="isLoading" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [rows]="5" [rowsPerPageOptions]="[5, 10, 25, 50]"
              [autoLayout]="true" sortMode="multiple" class="datatable" styleClass="p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                      <th *ngFor="let col of columns">
                          {{ col.header | translate}}
                      </th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                  <tr>
                      <td *ngFor="let col of columns" style="max-width: 300px;">
                          <ng-container [ngSwitch]="col.field">
                              <ng-container *ngSwitchCase="'isActivated'">
                                <div class="overflow-text">
                                  {{ rowData[col.field] | optionsMapping:isActivatedOptions | replaceNullWith:'-' }}
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchCase="'__action'">
                                <div class="overflow-text">
                                  <i class="pi pi-pencil" (click)="gotoModify($event, rowData)"></i>
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                  <div [ngSwitch]="col.dataType">
                                      <ng-container *ngSwitchCase="'date'">
                                        <div class="overflow-text">
                                          {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                        </div>
                                      </ng-container>
                                      <ng-container *ngSwitchDefault>
                                        <div class="overflow-text">
                                          {{ rowData[col.field] | replaceNullWith:'-'}}
                                        </div>
                                      </ng-container>
                                  </div>
                              </ng-container>
                          </ng-container>
                      </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                  <tr>
                      <td [attr.colspan]="6" style="text-align: center;">
                          {{ 'Common.Table.NoData' | translate }}
                      </td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
